import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  LinkButton,
  Messager,
  DateBox,
  NumberBox,
  Panel,
  ComboBox,
  PasswordBox,
  Tree,
  FileButton,
} from "rc-easyui";
import {
  entry_modules,
  report_modules,
  accountingModules,
  accountingReportsModules,
  setting,
} from "../../../constants/index";
import { getData } from "./Common";
import setTitle from "../../../helpers/TitleComponent";
import { Button } from "reactstrap";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { isEmpty, isEmptyString, getFormattedDate } from "../../../helpers";
import Unicode from "../../../helpers/Unicode";
import { API_URL } from "../../../constants";

const axios = require("axios");

export default class ClientRegistration extends Component {
  styleUniCode = { position: "absolute", top: "-65%", right: "1%" };
  provinceList = [
    { value: "Province 1", text: "Province 1" },
    { value: "Province 2", text: "Province 2" },
    { value: "Province 3", text: "Province 3" },
    { value: "Province 4", text: "Province 4" },
    { value: "Province 5", text: "Province 5" },
    { value: "Province 6", text: "Province 6" },
    { value: "Province 7", text: "Province 7" },
  ];

  wardList = [
    { value: 1, text: 1 },
    { value: 2, text: 2 },
    { value: 3, text: 3 },
    { value: 4, text: 4 },
    { value: 5, text: 5 },
    { value: 6, text: 6 },
    { value: 7, text: 7 },
    { value: 8, text: 8 },
    { value: 9, text: 9 },
    { value: 10, text: 10 },
    { value: 11, text: 11 },
    { value: 12, text: 12 },
    { value: 13, text: 13 },
    { value: 14, text: 14 },
    { value: 15, text: 15 },
    { value: 16, text: 16 },
    { value: 17, text: 17 },
    { value: 18, text: 18 },
    { value: 19, text: 19 },
    { value: 20, text: 20 },
    { value: 21, text: 21 },
    { value: 22, text: 22 },
    { value: 23, text: 23 },
    { value: 24, text: 24 },
    { value: 25, text: 25 },
    { value: 26, text: 26 },
    { value: 27, text: 27 },
    { value: 28, text: 28 },
    { value: 29, text: 29 },
    { value: 30, text: 30 },
    { value: 31, text: 31 },
    { value: 32, text: 32 },
    { value: 33, text: 33 },
  ];

  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.basic_info = React.createRef();
    this.technical_info = React.createRef();
    this.clientaccessinfo = React.createRef();
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.state = {
      moduleArray: [],
      pricePlanList: [],
      allMarketingAgentList: [],
      isLoading: false,
      file: [],
      clientbasicinfo: {
        organizationname: "",
        provience: "",
        city: "",
        wardno: "",
        addressone: "",
        addresstwo: "",
        phoneno: "",
        altphone: "",
        altphonetwo: "",
        weburl: "",
        contactpersonname: "",
        mobileno: "",
        altmobile: "",
        emailaddress: "",
        panvatnumber: "",
        regnumber: "",
        createdby: getCookie("username"),
        systemurl: "",
        mrid: "",
        enabled: "Active",
      },
      clienttechnicalinfo: {
        databaseuser: "",
        databasepassword: "",
        databasename: "",
        systemusername: "",
        systemuserpassword: "",
        systemuserfullname: "",
        smsapi: "",
        milkanalyzerinfo: "",
        datetype: "",
      },
      clientaccessinfo: {
        startdate: "",
        expirydate: "",
        allowedsystemusers: "",
        priceplanid: "",
        allowedplatfroms: "",
        systemuserpermissions: [],
        allowedmodules: [],
        renewcharge: "",
        installationcharge: "",
      },
      rules: {
        clientbasicinfo: {
          organizationname: ["required"],
          mrid: ["required"],
          provience: ["required"],
          emailaddress: ["email"],
          city: ["required"],
          // wardno: ["required"],
          addressone: ["required"],
          phoneno: {
            required: true,
          },
          contactpersonname: ["required"],
          mobileno: ["required"],
          panvatnumber: {
            required: true,
            length: {
              validator(value) {
                return value.length === 9 || value.length === 11;
              },
              message: "Pan/VAT number should either 9 digit or 11 digit",
            },
          },
          regnumber: ["required"],

          // weburl: {
          //   validation: {
          //     validator(value) {
          //       return value.match(
          //         /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          //         // new RegExp("https?:\/\/")

          //       );
          //     },
          //     message: "Enter a valid link",
          //   },
          // },
          // systemurl: {
          //   validation: {
          //     validator(value) {
          //       return value.match(
          //         /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          //       );
          //     },
          //     message: "Enter a valid link",
          //   },
          // },
        },
        clienttechnicalinfo: {
          databaseuser: ["required"],
          databasepassword: ["required"],
          databasename: ["required"],
          systemusername: {
            required: true,
            usernameFormat: {
              validator(value) {
                const regx = /^([0-9a-z]+$)/;
                return regx.test(value);
              },
              message:
                "small letter and combinatin of alphabet and number is supported",
            },
            usernameLength: {
              validator(value) {
                return value.length >= 5 && value.length <= 50;
              },
              message: "Username length should between 5 and 50",
            },
          },
          systemuserpassword: {
            required: true,
            passwordCriteria: {
              validator(value) {
                //console.log(value);
                const regx =
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
                return regx.test(value);
              },
              message:
                "Password field must have at least 1 Special , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 character length",
            },
          },
          systemuserfullname: ["required"],
        },
        clientaccessinfo: {
          startdate: ["required"],
          expirydate: ["required"],
          allowedsystemusers: ["required"],
          allowedplatfroms: ["required"],
          priceplanid: ["required"],
          renewcharge: {
            required: true,
            positiveNumber: {
              validator(value) {
                return value >= 0;
              },
              message: "This field should be a postive number",
            },
          },
          installationcharge: {
            required: true,
            positiveNumber: {
              validator(value) {
                return value >= 0;
              },
              message: "This field should be a postive number",
            },
          },
        },
      },
    };
  }

  componentDidMount() {
    setTitle("Client Registration");
    this.getPricePlanForComboBox();
    this.getDisplayModules();
    this.getMarketinRepresentativeForComboBox();
  }

  //function to handle image select option
  handleSelect = (file) => {
    console.log("handleSelect");
    if (file.length === 1) {
      if (file[0].size > 250000) {
        console.log("250000");
        this.messager.alert({
          title: "warning",
          icon: "warning",
          msg: "Maximum upload image size 250kb",
        });
        return;
      }
      if (
        file[0].type !== "image/png" &&
        file[0].type !== "image/jpg" &&
        file[0].type !== "image/jpeg"
      ) {
        console.log("type");
        return;
      }
    }
    this.setState({ file: file }, () => {
      console.log(this.state.file);
    });
  };

  //function to cancle selected image
  onImageCancleHandle = () => {
    this.fileInput.fileRef.value = "";
    this.setState({ file: [] });
  };

  async getDisplayModules() {
    let erp_access_token = getCookie("access_token");
    let erp_token_type = getCookie("token_type");
    let axiosConfig = {
      headers: {
        authorization: erp_token_type + " " + erp_access_token,
        "Content-Type": "application/json",
      },
    };
    if (erp_access_token != null) {
      this.setState({
        isLoading: true,
      });
      axios
        .get(API_URL + "public/displaymodulesdetail", axiosConfig)
        .then((response) => {
          if (response.status === 200 && response.data.status) {
            let dataObject = response.data.object;
            //console.log("dataObject", dataObject);

            let displayModules = dataObject;
            let moduleArray = Object.keys(displayModules);
            moduleArray.map((resData, key) => {
              //console.log(displayModules[resData],key)
              let modulesTreeData = getData(displayModules[resData], resData);
              this.setState({ [`modulesTreeData${resData}`]: modulesTreeData });
            });
            this.setState({ moduleArray: moduleArray, isLoading: false });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          alert("Internal server error");
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getDisplayModules();
      }
    }
  }

  renderAccessModules() {
    return this.state.moduleArray.map((resData) => {
      return (
        <div className="col-lg-3">
          <Tree
            data={this.state[`modulesTreeData${resData}`]}
            checkbox
            onCheckChange={this.handleCheckChange.bind(this)}
          ></Tree>
        </div>
      );
    });
  }

  handleRowCheckAll(id) {
    let tble = document.getElementById(id);
    let checkboxes = tble.querySelectorAll('input[type="checkbox"]');
    let val = checkboxes[0].checked;
    for (let i = 0; i < checkboxes.length; i++) checkboxes[i].checked = val;
  }

  handleCheckAll() {
    let items = document.getElementsByName("modules[]");
    if (document.getElementById("all").checked) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = true;
      }
    } else {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type === "checkbox") items[i].checked = false;
      }
    }
  }

  renderAccessModule() {
    let tableRows = [];
    let i = 1;
    for (let module in entry_modules) {
      tableRows.push(
        <tr id={i}>
          <td>{i}</td>

          <td>
            <input
              type="checkbox"
              className="check-create-read-only"
              name="modules[]"
              id={module}
              value={module}
            />{" "}
            {entry_modules[module]}
          </td>
        </tr>
      );
      i++;
    }
    return tableRows;
  }

  renderReportModule() {
    let tableRowsReport = [];
    let i = 1;
    for (let module in report_modules) {
      tableRowsReport.push(
        <tr id={`key${i}`}>
          <td>{i++}</td>
          <td>
            <input
              type="checkbox"
              className="check-create-read-only"
              name="modules[]"
              id={module}
              value={module}
            />{" "}
            {report_modules[module]}
          </td>
        </tr>
      );
    }
    return tableRowsReport;
  }

  // handleChange(name, value, form_name) {
  //   let user = Object.assign({}, this.state[form_name]);
  //   console.log(user);

  //   user[name] = value;
  //   // this.setState({ user: user });
  // }

  handleChange(form_name, name, value) {
    let user = Object.assign({}, this.state[form_name]);
    if (name === "phoneno" || name === "altphone") {
      var a = value.replace(/[^\d.-]/g, "");

      user[name] = a;
    } else {
      user[name] = value;
    }

    this.setState({ [form_name]: user });
  }

  handleSubmit() {
    console.log("submit");
    let clienttechnicalinfo = Object.assign({}, this.state.clienttechnicalinfo);
    let clientaccessinfo = Object.assign({}, this.state.clientaccessinfo);
    let clientbasicinfo = Object.assign({}, this.state.clientbasicinfo);

    console.log(clientbasicinfo);
    console.log(clientaccessinfo);

    clientaccessinfo["startdate"] = getFormattedDate(
      clientaccessinfo["startdate"]
    );
    clientaccessinfo["expirydate"] = getFormattedDate(
      clientaccessinfo["expirydate"]
    );

    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");

    let axiosConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      },
    };
    //var allowedmodulesString = clientaccessinfo["allowedmodules"].join();
    var allowedmodulesString = this.state.moduleArray;
    let allowedmod = [];
    allowedmodulesString.map((ele, i) => {
      if (
        clientaccessinfo["systemuserpermissions"].indexOf(ele.toLowerCase()) >=
        0
      ) {
        allowedmod.push(ele);
      }
    });
    clientaccessinfo["allowedmodules"] = allowedmod.join();
    var data = {
      clientbasicinfo: clientbasicinfo,
      clienttechnicalinfo: clienttechnicalinfo,
      clientaccessinfo: clientaccessinfo,
    };

    let emptyfile = new File([""], "", {
      type: "image/png",
    });

    let bodyFormData = new FormData();

    bodyFormData.append(
      "file",
      this.state.file.length > 0 ? this.state.file[0] : emptyfile
    );
    bodyFormData.append("jsonData", JSON.stringify(data));

    this.basic_info.current.validate(async (basic_info_errors) => {
      this.technical_info.current.validate(async (technical_info_errors) => {
        this.clientaccessinfo.current.validate(
          async (clientaccessinfo_errors) => {
            if (
              isEmpty(basic_info_errors) &&
              isEmpty(technical_info_errors) &&
              isEmpty(clientaccessinfo_errors)
            ) {
              if (access_token != null) {
                //Access Token Available
                //console.log(data);

                this.setState({
                  isLoading: true,
                });
                //console.log("data",data);
                //return false;
                // data.clientaccessinfo.expirydate = getFormattedDate(expirydate);
                // data.clientaccessinfo.startdate = getFormattedDate(startdate);
                axios
                  .post(
                    API_URL + "api/registerclient",
                    bodyFormData,
                    axiosConfig
                  )
                  .then((response) => {
                    if (response.status === 200) {
                      this.setState({
                        isLoading: false,
                      });

                      if (response.data.status) {
                        this.messager.alert({
                          title: "Success",
                          msg: response.data.message,
                          reload: true,
                        }); // CLient  Saved Successfully ie. 200
                      } else {
                        var message = "";
                        if (response.data.object) {
                          response.data.object.forEach((row, i) => {
                            message += "<p>" + row + "</p>";
                          });
                        } else {
                          message = response.data.message;
                        }
                        this.messager.alert({
                          title: "Error",
                          msg: message,
                          reload: false,
                        });
                      }

                      // this.props.formClear();
                    } else {
                      this.messager.alert({
                        title: "Error",
                        msg: "Uncaught Error",
                        reload: false,
                      });
                    }
                  })
                  .catch((error) => {
                    this.setState({
                      isLoading: false,
                    });
                    console.log(error);
                    this.messager.alert({
                      title: "Error",
                      msg: "Internal Server Error",
                      reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                      if (response.status === 400) {
                        var message = "";
                        response.data.errors.forEach((row, i) => {
                          message +=
                            "<p style='margin-bottom:3px;'>" +
                            row.defaultMessage +
                            "</p>";
                        });
                        this.messager.alert({
                          title: "Error",
                          msg: message,
                          reload: false,
                        }); // Backend Validation Error ie.400
                      } else {
                        this.messager.alert({
                          title: "Error",
                          msg: "UnCaught Error",
                          reload: false,
                        }); // Uncaught Backend Error ie.500 eyc.
                      }
                    } else {
                      this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                      }); // Caused due to syntax error in front end
                    }
                  });
              } else {
                //Access Token Expired.
                //Generate new Access Token using Refresh Token.
                const resp = await getAccessToken();
                if (resp) {
                  this.handleSave();
                }
              }
            } else {
              this.messager.alert({
                title: "Error",
                msg: "Please fill the required fields.",
              });
            }
          }
        );
      });
    });
  }

  async getPricePlanForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allpriceplan/`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              pricePlanList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }

  getMarketinRepresentativeForComboBox = async () => {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/getmarketingagentforcombo/`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              allMarketingAgentList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  };

  handleCheckChange(nodes) {
    var systemuserpermissions =
      this.state.clientaccessinfo.systemuserpermissions;
    var allowedmodules = this.state.clientaccessinfo.allowedmodules;
    //console.log("systemuserpermissions",systemuserpermissions);
    for (var key in nodes) {
      var current = nodes[key];
      if (systemuserpermissions.indexOf(current.id) < 0) {
        systemuserpermissions.push(current.id);
      }

      if (
        allowedmodules.indexOf(current.firstparent) < 0 &&
        current.firstparent !== undefined
      ) {
        allowedmodules.push(current.firstparent);
      }
    }

    this.setState({
      clientaccessinfo: {
        ...this.state.clientaccessinfo,
        systemuserpermissions,
        allowedmodules,
      },
    });
  }

  render() {
    const basic_info_rules = this.state.rules.clientbasicinfo;
    const technical_info_rules = this.state.rules.clienttechnicalinfo;
    const clientaccessinforules = this.state.rules.clientaccessinfo;
    const {
      accountingModulesTreeData,
      // dairyModulesTreeData,
      settingsModulesTreeData,
      reportsModulesTreeData,
      // tradingModulesTreeData,
      clientbasicinfo,
      clienttechnicalinfo,
      clientaccessinfo,
      allMarketingAgentList,
    } = this.state;
    var fileName = "";
    if (this.state.file.length === 1) {
      fileName = this.state.file[0].name;
    }

    return (
      <div className="container-fluid">
        <div className={this.state.isLoading ? "loadingmodel" : ""}></div>
        <div className="row">
          <div className="col-lg-6">
            <Messager
              ref={(ref) => (this.messager = ref)}
              showHeader={false}
              borderType="none"
              content={({ title, msg, buttons, reload }) => (
                <div className="alert-content">
                  <h3>{title}</h3>
                  <div
                    style={{ marginBottom: 5 }}
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                  <div className="m-buttons">
                    {buttons.map((button, index) => (
                      <LinkButton
                        key={index}
                        text={button.text}
                        onClick={() => {
                          this.messager.close(button);
                          if (reload) {
                            window.location.reload();
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}
            />
            <Panel
              collapsible
              title="Client Basic Info"
              bodyStyle={{ padding: 15, height: 1250 }}
            >
              <Form
                ref={this.basic_info}
                model={clientbasicinfo}
                style={{ marginTop: 10 }}
                labelWidth={160}
                labelAlign="left"
                rules={basic_info_rules}
                onChange={this.handleChange.bind(this, "clientbasicinfo")}
              >
                <FormField name="organizationname" label="Client Name:">
                  <TextBox value={clientbasicinfo.organizationname}></TextBox>
                  <div style={this.styleUniCode}>
                    <Unicode />
                  </div>
                </FormField>

                <FormField name="provience" label="Provience :">
                  <TextBox value={clientbasicinfo.provience}></TextBox>
                </FormField>

                <FormField name="city" label="City:">
                  <TextBox value={clientbasicinfo.city}></TextBox>
                </FormField>

                <FormField name="wardno" label="Ward No:">
                  <NumberBox value={clientbasicinfo.wardno}></NumberBox>
                </FormField>

                <FormField name="addressone" label="Address 1:">
                  <TextBox value={clientbasicinfo.addressone}></TextBox>
                </FormField>

                <FormField name="addresstwo" label="Address 2:">
                  <TextBox value={clientbasicinfo.addresstwo}></TextBox>
                </FormField>

                <FormField name="phoneno" label="Phone Number:">
                  <TextBox value={clientbasicinfo.phoneno}></TextBox>
                </FormField>

                <FormField name="altphone" label="Alt Phone :">
                  <TextBox value={clientbasicinfo.altphone}></TextBox>
                </FormField>
                <FormField name="altphonetwo" label="Alt Phone 2 :">
                  <TextBox value={clientbasicinfo.altphonetwo}></TextBox>
                </FormField>
                <FormField name="weburl" label="Software Link :">
                  <TextBox value={clientbasicinfo.weburl}></TextBox>
                </FormField>
                <FormField name="systemurl" label="System URL :">
                  <TextBox value={clientbasicinfo.systemurl}></TextBox>
                </FormField>
                <FormField
                  name="contactpersonname"
                  label="Contact Person Name:"
                >
                  <TextBox value={clientbasicinfo.contactpersonname}></TextBox>
                </FormField>
                <FormField name="mobileno" label="Mobile No:">
                  <NumberBox value={clientbasicinfo.mobileno}></NumberBox>
                </FormField>
                <FormField name="altmobile" label="Alt Mobile No:">
                  <TextBox value={clientbasicinfo.altmobile}></TextBox>
                </FormField>

                <FormField name="emailaddress" label="Email Address:">
                  <TextBox value={clientbasicinfo.emailaddress}></TextBox>
                </FormField>

                <FormField name="panvatnumber" label="PAN/VAT Number:">
                  <TextBox value={clientbasicinfo.panvatnumber}></TextBox>
                  <div style={this.styleUniCode}>
                    <Unicode />
                  </div>
                </FormField>
                <FormField name="regnumber" label="Darta Number :">
                  <TextBox value={clientbasicinfo.regnumber}></TextBox>
                </FormField>
                <FormField name="mrid" label="Marketing Agent:">
                  <ComboBox
                    data={allMarketingAgentList}
                    editable={true}
                    value={clientbasicinfo.mrid}
                    textField="name"
                    valueField="id"
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>
                <FormField name="enabled" label="Status:">
                  <ComboBox
                    data={[
                      { value: "Active", text: "Active" },
                      { value: "Inactive", text: "Inactive" },
                    ]}
                    editable={false}
                    value={clientbasicinfo.enabled}
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>
              </Form>
              <div className="d-flex justify-content-between">
                <p>Logo:</p>
                <div style={{ marginRight: "19.5rem" }}>
                  <FileButton
                    ref={(ref) => (this.fileInput = ref)}
                    accept="image/*"
                    value={this.state.file}
                    id="ccimemberphotoselect"
                    onSelect={(e) => this.handleSelect(e)}
                  >
                    Choose Logo
                  </FileButton>
                  <p
                    id="ccimemberRegistartionImageValidMessage"
                    style={{
                      color: isEmptyString(fileName) ? "green" : "blue",
                      position: "absolute",
                      marginTop: "0px",
                    }}
                    className="pt-1"
                  >
                    {isEmptyString(fileName) ? (
                      <>
                        {`Only png / jpg /jpeg allowed`}
                        <br></br>
                        {`Maximum size 250kb`}
                      </>
                    ) : (
                      <>
                        {fileName}
                        <span
                          onClick={this.onImageCancleHandle}
                          style={{
                            color: "red",
                            fontSize: "19px",
                            fontWeight: "700",
                            cursor: "pointer",
                            paddingLeft: "5px",
                          }}
                          color="red"
                        >
                          X
                        </span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            </Panel>
          </div>
          <div className="col-lg-6">
            <Panel
              collapsible
              title="Client Technical Info"
              bodyStyle={{ padding: 15 }}
            >
              <Form
                ref={this.technical_info}
                model={clienttechnicalinfo}
                labelWidth={160}
                labelAlign="left"
                rules={technical_info_rules}
                onChange={this.handleChange.bind(this, "clienttechnicalinfo")}
              >
                <FormField name="databasename" label="DB Name: ">
                  <TextBox value={clienttechnicalinfo.databasename}></TextBox>
                </FormField>

                <FormField name="databaseuser" label="DB User :">
                  <TextBox value={clienttechnicalinfo.databaseuser}></TextBox>
                </FormField>

                <FormField name="databasepassword" label="DB Password:">
                  <PasswordBox
                    value={clienttechnicalinfo.databasepassword}
                  ></PasswordBox>
                </FormField>

                <FormField
                  name="systemuserfullname"
                  label="System User Fullname: "
                >
                  <TextBox
                    value={clienttechnicalinfo.systemuserfullname}
                  ></TextBox>
                </FormField>

                <FormField name="systemusername" label="System  Username :">
                  <TextBox value={clienttechnicalinfo.systemusername}></TextBox>
                </FormField>

                <FormField
                  name="systemuserpassword"
                  label="System User Password:"
                >
                  <PasswordBox
                    value={clienttechnicalinfo.systemuserpassword}
                  ></PasswordBox>
                </FormField>

                <FormField name="smsapi" label="SMS API:">
                  <TextBox value={clienttechnicalinfo.smsapi}></TextBox>
                </FormField>

                <FormField name="milkanalyzerinfo" label="Milk Analyzer Info:">
                  <TextBox
                    value={clienttechnicalinfo.milkanalyzerinfo}
                  ></TextBox>
                </FormField>
                <FormField name="datetype" label="Date Type:">
                  <ComboBox
                    data={[
                      { value: "AD", text: "AD" },
                      { value: "BS", text: "BS" },
                    ]}
                    editable={false}
                    value={clientaccessinfo.datetype}
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>
              </Form>
            </Panel>
            <hr />
            <Panel
              collapsible
              title="Client Access Info"
              bodyStyle={{ padding: 20 }}
            >
              <Form
                ref={this.clientaccessinfo}
                model={clientaccessinfo}
                labelWidth={150}
                labelAlign="left"
                rules={clientaccessinforules}
                // labelPosition='left'
                onChange={this.handleChange.bind(this, "clientaccessinfo")}
              >
                <FormField name="startdate" label="Start Date:">
                  <DateBox
                    inputId="d2"
                    format="yyyy-MM-dd"
                    editable={false}
                    value={clientaccessinfo.startdate}
                    calendarOptions={{
                      validator: (date) => {
                        var now = new Date();
                        var d1 = new Date(
                          now.getFullYear(),
                          now.getMonth(),
                          now.getDate()
                        );

                        return d1 <= date;
                      },
                    }}
                    panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  ></DateBox>
                </FormField>

                <FormField name="expirydate" label="Expiry Date:">
                  <DateBox
                    inputId="d2"
                    format="yyyy-MM-dd"
                    editable={false}
                    value={clientaccessinfo.expirydate}
                    calendarOptions={{
                      validator: (date) => {
                        var now = new Date();
                        var d1 = new Date(
                          now.getFullYear(),
                          now.getMonth(),
                          now.getDate()
                        );

                        return d1 <= date;
                      },
                    }}
                    panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  ></DateBox>
                </FormField>

                <FormField
                  name="allowedsystemusers"
                  label="No. of user Allowed:"
                >
                  <NumberBox
                    value={clientaccessinfo.allowedsystemusers}
                  ></NumberBox>
                </FormField>
                <FormField name="allowedplatfroms" label="Allowed Platforms:">
                  <ComboBox
                    data={[
                      { value: "web", text: "Web" },
                      { value: "mobile", text: "Mobile" },
                      { value: "both", text: "Both" },
                    ]}
                    value={clientaccessinfo.allowedplatfroms}
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>

                <FormField name="priceplanid" label="Price Plan:">
                  <ComboBox
                    textField="planName"
                    valueField="id"
                    data={this.state.pricePlanList}
                    value={clientaccessinfo.priceplanid}
                    style={{ width: "100%" }}
                  ></ComboBox>
                </FormField>
                <FormField name="renewcharge" label="Renew Charge:">
                  <NumberBox
                    value={clientaccessinfo.renewcharge}
                    prefix="Rs."
                    precision={2}
                    spinners={true}
                  ></NumberBox>
                </FormField>
                <FormField
                  name="installationcharge"
                  label="Installation Charge:"
                >
                  <NumberBox
                    value={clientaccessinfo.installationcharge}
                    prefix="Rs."
                    precision={2}
                    spinners={true}
                  ></NumberBox>
                </FormField>
              </Form>
            </Panel>
          </div>
        </div>
        <hr />
        <h6>Allowed Modules</h6>
        <div className="row">
          <div className="row">{this.renderAccessModules()}</div>

          {/* <div className='col-lg-3'>
            <Tree
              data={dairyModulesTreeData}
              checkbox
              onCheckChange={this.handleCheckChange.bind(this)}
            ></Tree>
          </div>
          */}
          {/* <div className='col-lg-3'>
            <Tree
              data={tradingModulesTreeData}
              checkbox
              onCheckChange={this.handleCheckChange.bind(this)}
            ></Tree>
          </div> */}
        </div>

        {/* <div className='row' style={{ marginTop: 15, marginBottom: 15 }}>
          <div className='col-lg-12'>
            <Panel title='Module Access' bodyStyle={{ padding: 20 }}>
              <input
                type='checkbox'
                className=''
                id='all'
                name='modules[]'
                onChange={this.handleCheckAll.bind()}
              />{" "}
              <b>All Modules</b>
              <br />
              <div className='row'>
                <div className='col-lg-6 accesss-modules'>
                  <table className='table table-sm table-striped table-hover table-bordered'>
                    <thead>
                      <tr>
                        <th>Sr_no.</th>
                        <th>Entry Modules</th>
                      </tr>
                    </thead>

                    <tbody>{this.renderAccessModule()}</tbody>
                  </table>
                </div>
                <div className='col-lg-6 report-modules'>
                  <table className='table table-sm table-striped table-hover table-bordered'>
                    <thead>
                      <tr>
                        <th>Sr_no.</th>
                        <th>Reports Modules</th>
                      </tr>
                    </thead>

                    <tbody>{this.renderReportModule()}</tbody>
                  </table>
                </div>
              </div>
              <div className='row'></div>
            </Panel>
          </div>
        </div>
     
         */}
        <div style={{ marginBottom: 40, marginTop: 40 }}>
          <center>
            <Button
              // {...(this.state.loading ? "disabled" : "")}
              disabled={this.state.loading}
              color="primary"
              size="lg"
              onClick={this.handleSubmit}
            >
              Register Client
            </Button>
          </center>
        </div>
      </div>
    );
  }
}
